import type { ApiFileUploadType } from 'api/types/ApiFileUploadType';
import type { ApiEmbedSearchWidgetId } from 'api/types/ApiTypedId';

import { embedSearchWidgetApiCreatePresignedS3FileUpload } from './embedSearchWidgetApiCreatePresignedS3FileUpload';
import { embedSearchWidgetApiSendFileToS3PresignedUpload } from './embedSearchWidgetApiSendFileToS3PresignedUpload';

type Args = {
  embedSearchWidgetId: ApiEmbedSearchWidgetId;
  file: File;
  fileType: ApiFileUploadType;
};

export async function embedSearchWidgetApiUploadFile({
  embedSearchWidgetId,
  file,
  fileType,
}: Args) {
  const presignedUpload = await embedSearchWidgetApiCreatePresignedS3FileUpload(
    { embedSearchWidgetId, file, fileType },
  );

  const s3FileId = await embedSearchWidgetApiSendFileToS3PresignedUpload({
    embedSearchWidgetId,
    file,
    presignedUpload,
  });

  return s3FileId;
}
